import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { Theme, Page } from 'features/ui/types'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme, usePage } from 'hooks/useUiState'

const Link = styled.a.attrs({ target: '_blank', rel: 'noopener noreferrer' })<{
  mode: Theme
}>`
  color: ${({ mode }) => sys[mode].interaction.primary.default};
  cursor: ${({ href }) => (href ? 'pointer' : 'default')};
  &:hover {
    color: ${({ mode }) => sys[mode].interaction.primary.hover};
  }
  &:active {
    color: ${({ mode }) => sys[mode].interaction.primary.pressed};
  }
`

interface TooltipContentProps {
  allWidgetsReady?: boolean
  exporting?: boolean
}

const TooltipContent = ({ allWidgetsReady, exporting }: TooltipContentProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const page = usePage()

  if (page === Page.LiveReport) {
    if (!allWidgetsReady) {
      return <>{t('liveReportPdfExportTooltip')}</>
    }
    return null
  }

  if (exporting) {
    return <>{t('pdfExportingTooltip')}</>
  }

  if (!allWidgetsReady) {
    return <>{t('pdfExportTooltip')}</>
  }

  return (
    <span>
      <Trans
        i18nKey="learnMoreAboutPdfExport"
        components={{
          CustomLink: (
            <Link
              mode={theme}
              href="https://help.quid.com/en/articles/8834310-new-presentation-mode-updates"
            />
          )
        }}
      />
    </span>
  )
}

export default TooltipContent
